{
  "name": "@100mslive/hms-video",
  "version": "0.9.28",
  "license": "MIT",
  "main": "dist/index.cjs.js",
  "typings": "dist/index.d.ts",
  "module": "dist/index.js",
  "files": [
    "dist",
    "src"
  ],
  "engines": {
    "node": ">=10"
  },
  "exports": {
    ".": {
      "require": "./dist/index.cjs.js",
      "import": "./dist/index.js",
      "default": "./dist/index.js"
    }
  },
  "scripts": {
    "prestart": "rm -rf dist && yarn types:build",
    "start": "concurrently \"yarn dev\" \"yarn types\"",
    "dev": "node ../../scripts/dev",
    "build:only": "node ../../scripts/build",
    "build": "yarn build:only && yarn types:build",
    "types": "tsc -w",
    "types:build": "tsc -p tsconfig.json",
    "test": "jest --maxWorkers=1",
    "lint": "eslint -c ../../.eslintrc .",
    "lint:fix": "yarn lint --fix",
    "prepare": "yarn build",
    "size": "size-limit",
    "analyze": "size-limit --why",
    "format": "prettier --write src/**/*.ts"
  },
  "author": "100ms <tech-common@100ms.live>",
  "devDependencies": {
    "@types/dom-screen-wake-lock": "^1.0.1",
    "@types/sdp-transform": "^2.4.4",
    "@types/ua-parser-js": "^0.7.36",
    "@types/uuid": "^8.3.0",
    "jest-canvas-mock": "^2.3.1",
    "jsdom-worker": "^0.3.0",
    "tslib": "^2.2.0"
  },
  "dependencies": {
    "eventemitter2": "^6.4.7",
    "sdp-transform": "^2.14.1",
    "ua-parser-js": "^1.0.1",
    "uuid": "^8.3.2",
    "webrtc-adapter": "^8.0.0"
  },
  "gitHead": "2616c7f5408ccbe73ba402514ca7b87b310d377c"
}
